/** TOP 表示：referrer ベースでヘッダー + KV フェードイン */
export const TOP_INTRO_DURATION_MS = 600;
export const TOP_INTRO_KV_DELAY_MS = 150;
export const TOP_INTRO_FALLBACK_MS = 3000;

const HTML_PENDING_CLASS = 'is-top-intro-pending';
const HTML_READY_CLASS = 'is-top-intro-ready';
const HTML_DONE_CLASS = 'is-top-intro-done';

function isTopPagePathname(pathname) {
	return pathname === '/' || pathname === '/index.html' || /\/top\.html$/.test(pathname);
}

/** @returns {boolean} 同一オリジンかつ直前ページが TOP */
export function isReferrerFromTopPage() {
	const ref = document.referrer;
	if (!ref) return false;
	try {
		const refUrl = new URL(ref);
		if (refUrl.origin !== location.origin) return false;
		return isTopPagePathname(refUrl.pathname);
	} catch {
		return false;
	}
}

/** @returns {boolean} */
export function shouldPlayTopIntro() {
	if (!document.body.classList.contains('is-top')) return false;
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
	return !isReferrerFromTopPage();
}

/** @returns {boolean} */
export function isTopIntroPending() {
	return document.documentElement.classList.contains(HTML_PENDING_CLASS);
}

/**
 * @param {(() => void) | undefined} onComplete
 */
function finishTopIntro(onComplete) {
	const html = document.documentElement;
	if (!html.classList.contains(HTML_PENDING_CLASS) && !html.classList.contains(HTML_READY_CLASS)) {
		onComplete?.();
		return;
	}

	html.classList.remove(HTML_PENDING_CLASS);
	html.classList.add(HTML_READY_CLASS);

	window.setTimeout(function () {
		html.classList.add(HTML_DONE_CLASS);
		html.classList.remove(HTML_READY_CLASS);
		onComplete?.();
	}, TOP_INTRO_KV_DELAY_MS + TOP_INTRO_DURATION_MS);
}

/**
 * MV スライダー mount 後にフェードイン開始
 * @param {(() => void) | undefined} onComplete autoplay 開始など
 */
export function completeTopMvMountForIntro(onComplete) {
	if (!isTopIntroPending()) {
		onComplete?.();
		return;
	}

	requestAnimationFrame(function () {
		requestAnimationFrame(function () {
			finishTopIntro(onComplete);
		});
	});
}

/** mount 前に pending のまま固まった場合のフォールバック */
export function initTopIntroFallback(onForceComplete) {
	if (!isTopIntroPending()) return;

	window.setTimeout(function () {
		if (!isTopIntroPending()) return;
		finishTopIntro(onForceComplete);
	}, TOP_INTRO_FALLBACK_MS);
}
